<template>
  <div>
    <card class="w-100" v-if="$store.state.account.roleCode === 'ADMIN'">
      <el-row :gutter="10">
        <form @submit.prevent="search()">
          <el-col :span="4">
            <div class="form-group">
              <label>가~하, A~Z</label>
              <el-select v-model="searchCompanyName" placeholder="검색조건을 선택하세요." @change="changeCompanyName">
                <el-option
                  v-for="item in keywordOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label>광고주</label>
              <el-select v-model="searchParam.searchCompanySeq" filterable placeholder="광고주를 선택하세요." @change="changeCompany">
                <el-option
                  v-for="item in this.$store.state.settingsCompany.company"
                  :key="item.companySeq"
                  :label="item.companyName"
                  :value="item.companySeq">
                </el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="form-group">
              <label>사업자등록번호</label>
              <el-input v-model="searchParam.searchLicenseNumber" placeholder="사업자등록번호">
              </el-input>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="form-group">
              <label>매체구분</label>
              <el-select v-model="searchParam.searchMediaType">
                <el-option
                  key=""
                  value=""
                  label="전체"></el-option>
                <el-option
                  key="AM"
                  value="AM"
                  label="통합매체"></el-option>
                <el-option
                  key="WC"
                  value="WC"
                  label="와이드칼라"></el-option>
                <el-option
                  key="DM"
                  value="DM"
                  label="디지털미디어"></el-option>
              </el-select>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="pull-right-top24">
              <el-button type="primary" native-type="submit" icon="el-icon-search">검색</el-button>
            </div>
          </el-col>
        </form>
      </el-row>
    </card>
    <card class="w-100">
      <el-col :span="24">
        <el-col :span="24" v-if="$store.state.account.roleCode === 'ADMIN'">
          <el-form class="form-horizontal" ref="ruleForm" label-width="135px">
          <el-form-item label="광고주 열람 허용여부" prop="name">
            <el-checkbox v-model="isDownload" @change="setContractDownload"></el-checkbox>
          </el-form-item>
          </el-form>
        </el-col>
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="$store.state.contract.contracts"
                  ref="contractsTable"
                  :header-cell-style="tableRowStyle">
          <el-table-column
          sortable
            prop="mediaTypeText"
            label="매체구분">
          </el-table-column>
          <el-table-column
          sortable
            prop="fileName"
              label="파일명">
          </el-table-column>
          <el-table-column
          sortable
          prop="size"
            label="용량">
            <template slot-scope="props">
              {{ props.row.size | numeral('0,0b')}}
            </template>
          </el-table-column>
          <el-table-column
          sortable
          prop="regDate"
            label="등록일">
            <template slot-scope="props">
              {{ props.row.regDate | moment('YYYY-MM-DD')}}
            </template>
          </el-table-column>
          <el-table-column
            v-if="$store.state.account.roleCode === 'ADMIN' || $store.state.contract.contractDownload"
            label="다운로드">
            <template slot-scope="props">
              <el-button  icon="el-icon-paperclip" @click="download(props.$index, props.row)">다운로드</el-button>
            </template>
          </el-table-column>
          <el-table-column
            v-if="$store.state.account.roleCode === 'ADMIN'"
            label="관리">
            <template slot-scope="props">
              <el-button  icon="el-icon-delete" @click="handleDelete(props.$index, props.row)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      <el-col :span="24" v-if="$store.state.account.roleCode === 'ADMIN'">
        <div class="pull-right">
          <el-button type="primary" icon="el-icon-plus" v-on:click="showModal(true)">계약서 등록</el-button>
        </div>
      </el-col>
    </card>
    <modal :show.sync="modals.isShow"
           footerClasses="justify-content-center"
           type="notice">
      <h5 slot="header" class="modal-title">계약서 등록</h5>
      <template>
        <el-form class="form-horizontal" ref="uploadForm" label-width="120px">
          <el-form-item label="매체구분" prop="mediaType">
            <el-select v-model="formData.mediaType">
              <el-option
                key="AM"
                value="AM"
                label="통합매체"></el-option>
              <el-option
                key="WC"
                value="WC"
                label="와이드칼라"></el-option>
              <el-option
                key="DM"
                value="DM"
                label="디지털미디어"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="계약서첨부" prop="upload">
            <el-upload
              class="upload-demo"
              ref="upload"
              action="/api/advertiser/contract"
              :headers="header"
              :data="getFormParam"
              :limit="1"
              :on-success="handleSuccess"
              :auto-upload="false">
              <el-button slot="trigger" size="small" type="primary">계약서 선택</el-button>
            </el-upload>
          </el-form-item>
          <div class="pull-right mt-2">
            <el-button type="primary" icon="el-icon-check" @click="submitUpload">저장</el-button>
            <el-button icon="el-icon-close" v-on:click="showModal(false)">취소</el-button>
          </div>
        </el-form>
      </template>
    </modal>
  </div>
</template>

<script>
    import Vue from 'vue'
    import {Table, TableColumn, Form, FormItem, Select, Input, Button, Row, Col, Checkbox, Option, Upload} from 'element-ui'
    import {Modal} from 'src/components/UIComponents'
    import VueMoment from 'vue-moment'
    import vueNumeralFilterInstaller from 'vue-numeral-filter';
    import { mapState } from 'vuex';

    Vue.use(vueNumeralFilterInstaller)
    Vue.use(VueMoment)
    Vue.use(Table)
    Vue.use(TableColumn)
    Vue.use(Select)
    Vue.use(Checkbox)
    Vue.use(Button)
    Vue.use(Row)
    Vue.use(Col)
    Vue.use(Input)
    Vue.use(Form)
    Vue.use(FormItem)
    Vue.use(Option)
    Vue.use(Upload)

    export default {
        name: "AdvertiserContract",
        created: function () {
            this.$store.commit('contract/INIT'); //state.contract.contracts = [];
            this.$store.dispatch('common/setMenuTitle', "서면 계약");
            if(this.$store.state.account.roleCode === 'ADMIN') {
                this.getAdvertisers();
            } else if (this.$store.state.account.roleCode === 'ADVERTISER') {
                this.searchParam.searchCompanySeq = this.$store.state.account.companySeq;
                this.search();
            }
        },
        updated: function () {
            this.$refs.contractsTable.doLayout();
        },
        components: {
            Modal
        },
        watch: {
            // 클래스 바인딩 확인용
            companySeqAlias(newValue, oldValue) {
                if(newValue > 0) {
                    this.searchParam.searchCompanySeq = newValue;
                }
            },
            contractDownloadAlias(newValue, oldValue) {
              this.isDownload = newValue;
            }
        },
        computed: {
            ...mapState({
                 companySeqAlias: state => state.contract.companySeq,
                contractDownloadAlias: state => state.contract.contractDownload,

            }),
            getFormParam: function () {
                return {
                    mediaType: this.formData.mediaType,
                    companySeq: this.searchParam.searchCompanySeq
                }
            }
        },
        methods: {
            tableRowStyle() {
                return this.$store.state.common.tableHeaderCellStyle;
            },
            showModal(isShow) {
                if(this.searchParam.searchCompanySeq === "") {
                    alert("광고주를 선택하세요.");
                } else {
                    this.$refs.upload.clearFiles();
                    this.$refs['uploadForm'].resetFields();
                    this.modals.isShow = isShow;
                }
            },
            submitUpload() {
                if(this.searchParam.searchCompanySeq === "") {
                    alert("광고주를 선택하세요.");
                } else if(this.$refs.upload.uploadFiles.length > 0) {
                    this.$refs.upload.submit();
                } else {
                    alert("계약서를 선택하세요.");
                }
            },
            handleSuccess(response, files, fileList) {
                this.showModal(false);
                this.search();
            },
            search() {
                if(this.searchParam.searchCompanySeq === "" && this.searchParam.searchLicenseNumber === "") {
                    alert("광고주를 선택하거나 사업자등록번호를 입력하세요.");
                } else {
                    this.$store.dispatch('contract/findAll', this.searchParam)
                }
            },
            getAdvertisers() {
                let param = {
                  roleCode: "ADVERTISER",
                  searchKey: this.searchCompanyName,
                  rows: 10000
                };
                this.$store.dispatch('settingsCompany/findAll', param);
            },
            changeCompany(value) {
                this.searchParam.searchLicenseNumber = '';
                this.search();
            },
            changeCompanyName(value) {
                this.getAdvertisers();
            },
            download(index, row) {
                location.href = "/api/advertiser/contract/" + row.contractSeq + "/download?authorization=" + $cookies.get('id_token');
            },
            handleDelete(index, row) {
                if(confirm("계약서를 삭제하시겠습니까?")) {
                    this.searchParam.contractSeq = row.contractSeq
                    this.$store.dispatch('contract/deleteContract', this.searchParam);
                }
            },
            setContractDownload(value) {
                if(this.searchParam.searchCompanySeq === "") {
                    alert("광고주를 선택하거나 사업자등록번호를 입력하세요.");
                    this.isDownload = false;
                } else {
                    let param = {
                        companySeq: this.searchParam.searchCompanySeq,
                        download: value
                    };
                    this.$store.dispatch('settingsCompany/updateContractDownload', param);
                }
            }
        },
        data() {
            return {
                header: {
                    Authorization:$cookies.get('id_token')
                },
                formData: {
                    mediaType: "AM",
                },
                isDownload: false,
                modals: {
                    isShow: false,
                },
                keywordOptions: [
                    {label: '전체',value: ''},
                    {label: '가',value: '가'},
                    {label: '나',value: '나'},
                    {label: '다',value: '다'},
                    {label: '라',value: '라'},
                    {label: '마',value: '마'},
                    {label: '바',value: '바'},
                    {label: '사',value: '사'},
                    {label: '아',value: '아'},
                    {label: '자',value: '자'},
                    {label: '차',value: '차'},
                    {label: '카',value: '카'},
                    {label: '타',value: '타'},
                    {label: '파',value: '파'},
                    {label: '하',value: '하'},
                    {label: 'A-z',value: 'a'}
                  ],
                searchParam: {
                    searchMediaType: '',
                    searchCompanySeq: '',
                    searchLicenseNumber: ''
                },
                searchCompanyName: '',
            }
        }
    }
</script>

<style scoped>
  .el-form-item {
    margin-bottom: 0px;
  }
</style>

<style>

  .el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: #212529 !important;
  }
  .bg-purple-light {
    background: #f8f9fc;
  }
</style>
